import * as React from 'react';
import {View} from 'react-native';

import {styles} from './EmptyReportContent.style';

export const EmptyReportContent = () => <View style={styles.divider} />;

export default EmptyReportContent;
